import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "note" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M15.3393 14.4286H20.5V4.41071C20.5 3.90603 20.094 3.5 19.5893 3.5H4.41071C3.90603 3.5 3.5 3.90603 3.5 4.41071V19.5893C3.5 20.094 3.90603 20.5 4.41071 20.5H14.4286V15.3393C14.4286 14.8384 14.8384 14.4286 15.3393 14.4286ZM20.2344 16.5156L16.5156 20.2344C16.3449 20.4051 16.1134 20.5 15.8705 20.5H15.6429V15.6429H20.5V15.8743C20.5 16.1134 20.4051 16.3449 20.2344 16.5156Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }